<footer class="working-footer bg-primary text-white py-3">
  <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
    <span>&copy; 2026 Gestión. Todos los derechos reservados.</span>
    <span class="small">Panel de administración de dispositivos</span>
  </div>
</footer>
